import axios from "./AxiosService";
import store from "../Store";
import { SET_XSRF_TOKEN } from "../actions/networkStateActions";

export default async function logoutService() {
  try {
    await axios.post("logout", null, { avoidLoadingFeature: true });
  } catch (e) {}
  store.dispatch({ type: SET_XSRF_TOKEN, payload: undefined });
}
